// extracted by mini-css-extract-plugin
export default {"main":"SimilarBooks_main__d+KBY","title":"SimilarBooks_title__f12Lh","bookList":"SimilarBooks_bookList__1Jt0L"};